import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { toastService } from "@miplatform/toast";
import { useGlobalManagerApproval } from "@mibuildweb/components";

export const useNewOrderActionsViewModel = ({ onRefresh }) => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const { executeApiRequest } = useGlobalManagerApproval();

  const approveOrder = (orderId, data) => {
    return stateManager.run(async () => {
      const options = await taskService.order.getApproveOptions({
        orderId,
        data,
      });
      const response = await executeApiRequest({
        options,
        callback: onRefresh,
        noInitialErrorMessage: true,
      });

      if (response.status === HTTP_STATUSES.OK) {
        toastService.success({ text: "Order approved successfully." });
      }
      return response.status === HTTP_STATUSES.OK;
    });
  };

  return { isLoading, approveOrder };
};
